module.exports = __webpack_public_path__ + "img/step3_wechatpay@3x.823fd520.png";